export default {
      id: "oc-h3c-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-h3c",
      toString: function () {
        return this.url;
      }
    }